module.exports = __webpack_public_path__ + "img/icon_visits.210cceda.png";